import { useState, useEffect } from "react";
import './ObjectMetadata.css';

const ObjectMetadata = ({metadata}) => {

  const [metaData, setMetaData] = useState({person: [], title: [], year: [], place: []});
 
  // parse metadata on initial render
  useEffect(() => {
    let { person, title, year, place } = parseMetadata(metadata);
    setMetaData({person, title, year, place});
  }, []);

  // format metadata arrays for display, add target="_blank" to links
  const parseMetadata = (data) => {
    let person = [];
    let title = [];
    let year = [];
    let place = [];

    data.forEach((item) => {
      const label = item.label.de[0];

      switch (label) {
        case 'Person':
          let p = item.value.none || item.value.de || [];
          person = p.map(p => addTargetBlankToLinks(p));
          break;
        case 'Titel':
          let t = item.value.none || item.value.de || [];
          title = t.map(t => addTargetBlankToLinks(t));
          break;
        case 'Jahr/Datierung':
          let y = item.value.none || item.value.de || [];
          year = y.map(y => addTargetBlankToLinks(y));
          break;
        case 'Erscheinungsort':
          let pl = item.value.none || item.value.de || [];
          place = pl.map(pl => addTargetBlankToLinks(pl));
          break;
        default:
          break;
      }
    });

    return { person, title, year, place };
  };

  const addTargetBlankToLinks = (html) => {
    return html.replace(/<a /g, '<a target="_blank" ');
  };

  return (
    <div>
      {
      metaData.person.length > 0 && 
      <div> <h4 className="metadata-label">Person</h4> {metaData.person.map((person, index) => (
          <div className="metadata-content" key={index} dangerouslySetInnerHTML={{ __html: person }} />
        ))}
      </div>
      }
      {
        metaData.title.length > 0 && 
        <div> <h4 className="metadata-label">Titel</h4> {metaData.title.map((title, index) => (
          <div className="metadata-content" key={index} dangerouslySetInnerHTML={{ __html: title }} />
        ))}
        </div>
      }
      {
        (metaData.year.length > 0 || metaData.place.length > 0) && (
          <div>
            <h4 className="metadata-label">Jahr/Datierung, Ort</h4>
            <span className="metadata-content">
              {[
                ...metaData.year,
                ...metaData.place
              ]
                .filter(item => item.length > 0)
                .map((item, index, array) => (
                  <span key={index}>
                    <span dangerouslySetInnerHTML={{ __html: item }} />
                    {index < array.length - 1 && ', '}
                  </span>
                ))}
            </span>
          </div>
        )
      }
    </div>
  );
};

export default ObjectMetadata;